<template>
  <div class="waste-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.wasteManagement') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="wasteShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'WasteHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            wasteShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.wasteTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.disposeOfSample'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.undoDisposeOfSample')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.undoDisposeOfSample'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.undoDisposeOfSample')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
